import React from 'react';
import Theme from 'src/components/Theme';
import { Paragraph, SectionSubtitle } from 'src/components/Typography';
import { AnchorButton } from 'src/components/Button';

const BootcampTypeBannerLarge = ({ isFullTimePage }) => {
  return (
    <Theme theme="ternary">
      <div
        css={{
          margin: '0 auto',
          maxWidth: 1350,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          padding: '0 100px',
        }}
      >
        <div
          css={(theme) => ({
            backgroundColor: theme.backgroundColor,
            borderRadius: 5,
            marginBottom: -169,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: 64,
            zIndex: 10,
          })}
        >
          <SectionSubtitle>
            Vous préférez le temps {isFullTimePage ? 'partiel' : 'plein'} ?
          </SectionSubtitle>
          <Paragraph css={{ textAlign: 'center' }}>
            Nous proposons aussi cette formation{' '}
            {isFullTimePage
              ? `en cours du soir et
            week-end sur une période de 6 mois`
              : `du lundi au vendredi sur une période de 10 semaines`}
            .
          </Paragraph>
          <div css={{ display: 'flex', justifyContent: 'center' }}>
            <AnchorButton
              to={
                isFullTimePage
                  ? '/bootcamp-javascript/formation-developpeur-web-mobile-temps-partiel/'
                  : '/bootcamp-javascript/formation-developpeur-web-mobile/'
              }
            >
              Découvrir la formation à temps {isFullTimePage ? 'partiel' : 'plein'}
            </AnchorButton>
          </div>
        </div>
      </div>
    </Theme>
  );
};

export default BootcampTypeBannerLarge;
